var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_doc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-30.000000, -63.000000)",
    fill: "#3360A2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5,77 L41,77 L39,69.5 L37,77 L35.5,77 L33.1,67 L34.8,67 L36.34,74.5 L38.3,67 L39.7,67 L41.67,74.5 L43.2,67 L44.9,67 L42.5,77 Z M46,63 L32,63 C30.89,63 30,63.89 30,65 L30,79 C30,80.1045695 30.8954305,81 32,81 L46,81 C47.1045695,81 48,80.1045695 48,79 L48,65 C48,63.89 47.1,63 46,63 Z",
    id: "icon_doc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.42e3b7459bbb4320213686aa1add5d68.svg";
export { ForwardRef as ReactComponent };